import {
  paletteHelper,
  spacingHelper,
  Stack,
  Text,
  typographyHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const Part1 = styled(Text).attrs(() => ({
  forwardedAs: 'span',
  variant: 'title01',
}))`
  margin-top: ${spacingHelper('extraSmall')};
`;

const Part2 = styled(Text).attrs(() => ({
  forwardedAs: 'span',
}))`
  line-height: 100%;
  ${typographyHelper('title03Light')}
  color: ${paletteHelper('textSecondary')};
`;

interface TitleByPartsProps {
  part1: string;
  part2: string;
}

export const TitleByParts: FunctionComponent<TitleByPartsProps> = ({ part1, part2 }) => {
  return (
    <Stack as="h1" gap="0">
      <Part1>{part1}</Part1> <Part2>{part2}</Part2>
    </Stack>
  );
};
